import { defineMessage } from 'services/localization';

export const messages = {
    popupTitle: defineMessage('cin_core_account_connection'),
    connectButton: defineMessage('connect'),
    fieldAccountId: defineMessage('cin_core_account_id'),
    fieldApplicationKey: defineMessage('application_key'),
    errorFieldAccountId: defineMessage('account_id_is_not_valid'),
    errorFieldApplicationKey: defineMessage('application_key_is_not_valid'),
    errorCompanyCreate: defineMessage('failed_to_create_company'),
};
